"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditTaskNote = exports.AddTaskNote = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@escolalms/sdk/lib/react");
var react_i18next_1 = require("react-i18next");
var __1 = require("../../../");
var common_1 = require("../TaskDetailsModal/content/common");
var useAutosizeTextArea_1 = __importDefault(require("../../../hooks/useAutosizeTextArea"));
var AddTaskNote = function (_a) {
    var taskId = _a.taskId, onSuccess = _a.onSuccess;
    var createTaskNote = (0, react_1.useContext)(react_2.EscolaLMSContext).createTaskNote;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(""), value = _b[0], setValue = _b[1];
    var _c = (0, react_1.useState)(false), loading = _c[0], setLoading = _c[1];
    var onAddNote = (0, react_1.useCallback)(function () {
        setLoading(true);
        createTaskNote(taskId, value)
            .then(function () {
            onSuccess();
            setValue("");
        })
            .finally(function () { return setLoading(false); });
    }, [taskId, value]);
    return ((0, jsx_runtime_1.jsxs)(common_1.AddNoteWrapper, { children: [loading && (0, jsx_runtime_1.jsx)(__1.Spin, {}), (0, jsx_runtime_1.jsx)(__1.TextArea, { name: "note", label: t("Tasks.Note"), placeholder: t("Tasks.AddNote"), value: value, onChange: function (e) { return setValue(e.target.value); } }), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ disabled: Boolean(!value), type: "button", mode: "secondary", onClick: function () { return onAddNote(); } }, { children: t("Tasks.AddNote") }))] }));
};
exports.AddTaskNote = AddTaskNote;
var EditTaskNote = function (_a) {
    var note = _a.note, onEdit = _a.onEdit, onDelete = _a.onDelete;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useContext)(react_2.EscolaLMSContext), updateTaskNote = _b.updateTaskNote, deleteTaskNote = _b.deleteTaskNote;
    var _c = (0, react_1.useState)(note.note), value = _c[0], setValue = _c[1];
    var _d = (0, react_1.useState)(false), loading = _d[0], setLoading = _d[1];
    var textAreaRef = (0, react_1.useRef)(null);
    (0, useAutosizeTextArea_1.default)(textAreaRef.current, value);
    var onEditNote = (0, react_1.useCallback)(function () {
        setLoading(true);
        updateTaskNote(note.task_id, note.id, value)
            .then(function () { return onEdit(); })
            .finally(function () { return setLoading(false); });
    }, [note, value]);
    var onDeleteNote = (0, react_1.useCallback)(function () {
        var result = window.confirm("Are you sure you want to delete this note?");
        if (result) {
            setLoading(true);
            deleteTaskNote(note.id)
                .then(function () { return onDelete(); })
                .finally(function () { return setLoading(false); });
        }
    }, [note]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: loading ? ((0, jsx_runtime_1.jsx)(__1.Spin, {})) : ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(__1.TextArea, { textAreaRef: textAreaRef, name: "note", placeholder: t("Tasks.EditNote"), value: value, onChange: function (e) { return setValue(e.target.value); } }), (0, jsx_runtime_1.jsxs)(__1.Row, __assign({ "$gap": 6, "$alignItems": "center", "$justifyContent": "space-around" }, { children: [value !== note.note && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(__1.Button, __assign({ mode: "secondary", type: "button", onClick: function () { return setValue(note.note); } }, { children: t("Tasks.Undo") })), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ mode: "secondary", type: "button", onClick: function () { return onEditNote(); } }, { children: t("Tasks.Save") }))] })), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ mode: "secondary", type: "button", onClick: function () { return onDeleteNote(); } }, { children: t("Tasks.Delete") }))] }))] })) }));
};
exports.EditTaskNote = EditTaskNote;
